<script>
	import { fade } from "svelte/transition";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h2 class="text-center">Litigation Funding Agreement and Conditional Costs Agreements</h2>
			<p>
				{$model.IsDeceased ? "To the Personal Representative of the Estate of" : "Dear"}
				{$model.FirstName}
				{$model.Surname},
			</p>

			<p>
				To allow Shine Lawyers to deliver all legal and professional work required to run the Ruby Princess
				Class Action and to verify, conduct and quantify your claim, we request you sign the Litigation Funding
				and Conditional Costs Agreement.
			</p>
			<p>
				To access and agree to the Litigation Funding Agreement and Conditional Costs Agreement, please click on
				the button below. Please note that your signature is not required to sign these online agreements.
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons showPrevious="false" {nextPage} nextPageLabel="ACCESS AGREEMENTS"></NavigationButtons>
		</div>
	</div>
	<div class="row justify-content-md-center" style="margin-top: 12px;">
		<div class="col-md-8 col-sm-12">
			<p>
				If you require support accessing or signing these documents, please contact us on
				<span style="white-space:nowrap">{projectSettings.phoneNumber}</span> or via email to
				<a href="mailto:{projectSettings.emailAddress}" target="_blank" rel="noreferrer noopener"
					>{projectSettings.emailAddress}</a
				>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
